<template>
  <div>
    <h5>{{ header }}</h5>
    <b-row>
      <b-col 
        v-for="(item, index) in items" 
        :key="index" 
        md="3" 
        class="mb-4">
        <b-card>
          <slot :item="item">
            <div>Replace your own component</div>
          </slot>
          <b-button 
            class="float-right" 
            variant="outline-danger" 
            @click="$emit('ontrashclick', item)"><i class="fa fa-trash"/></b-button>
        </b-card>
      </b-col>
      <b-col md="3">
        <b-button 
          variant="outline-info" 
          @click="$emit('onaddclick')">Add new</b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>

export default {

  props: {
    header: String,
    items: {
      type: Array,
      required: true
    }
  }

}
</script>
